import {differenceInSeconds} from 'date-fns';
import {isFeatureEnabled} from 'feature-flags';
import {NumberFormatter} from 'platform/locale';

import {SourcingVehicleResponseBody} from '@dms/api/core';
import {featureFlags} from '@dms/feature-flags';

import {Nullish, parseDate} from 'shared/web';

import {formatTimeDifferenceToNow} from './formatTimeDifferenceToNow';

export function getAdvertisedTime(
  sourcingVehicle: SourcingVehicleResponseBody | Nullish,
  formatNumber: NumberFormatter
) {
  const firstOccurrenceDateTime = parseDate(sourcingVehicle?.occurrence?.first ?? 0);
  const isMidnight = // Workaround for T20-100941
    firstOccurrenceDateTime?.getUTCHours() === 0 &&
    firstOccurrenceDateTime?.getUTCMinutes() === 0 &&
    firstOccurrenceDateTime?.getUTCSeconds() === 0;
  const difference = differenceInSeconds(new Date(), firstOccurrenceDateTime);
  const shouldShowTime =
    isFeatureEnabled(featureFlags.SOURCING_REAL_TIME_ADVERTISEMENT) &&
    !isMidnight &&
    difference <= 24 * 60 * 60 &&
    difference >= 0;
  const daysOnStock = sourcingVehicle?.daysOnStock ?? 0;
  const firstOccurrenceDistance = shouldShowTime
    ? formatTimeDifferenceToNow(firstOccurrenceDateTime)
    : formatNumber(daysOnStock, 0);

  return {
    firstOccurrenceDateTime,
    shouldShowTime,
    firstOccurrenceDistance,
  };
}
